/**
 * @description Hook utilizado para manipular os exames de constatação
 * @author Diego Sabino Amorim de Araújo
 * @file useExameConstatacaoService.js
 * @license Copyright (c) 2023 SIGEP DIGETI ITEP/RN
 */

import { useFetch } from './useFetch'

export const useExameConstatacaoService = () => {
  const fetch = useFetch()

  const listarExameConstatacaoParaExameAsync = async (id, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/exameConstatacao/paraExame/${id}`)
      return response.data.exameConstatacao
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarExameConstatacaoParaExameDetalhadoAsync = async (id, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/exameConstatacao/paraExame/detalhado/${id}`)
      return response.data.exameConstatacao
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const cadastrarAnaliseConstatacao = async (idDescricaoTecnica, idExameRealizado, definitivo = false, dados, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const dadosCadastro = {
        id_exame_realizado: definitivo ? idExameRealizado : null,
        id_exame_constatacao: !definitivo ? idExameRealizado : null,
        id_descricao_tecnica_vestigio: idDescricaoTecnica,
        resultado: dados.resultado,
        uso_proscrito_brasil: dados.uso_proscrito_brasil,
        metodConsts: dados.metodConsts ? dados.metodConsts.map((m) => m.id) : null,
        subsQuims: dados.subsQuims ? dados.subsQuims.map((q) => q.id) : null,
        outroTipoSubstancia: dados.outroTipoSubstancia,
      }

      await fetch.postOpen(`/exameConstatacao/analiseConstatacao`, dadosCadastro)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarAnaliseConstatacaoDeDescricaoEmExameAsync = async (idDescricao, idExameRealizado) => {
    try {
      const response = await fetch.get(`/exameConstatacao/deDescricao/emExame/${idDescricao}/${idExameRealizado}`)
      return response.data.analiseConstatacao
    } catch (err) {
      return null
    }
  }

  return {
    listarExameConstatacaoParaExameAsync,
    listarExameConstatacaoParaExameDetalhadoAsync,
    cadastrarAnaliseConstatacao,
    listarAnaliseConstatacaoDeDescricaoEmExameAsync,
  }
}
